import _extends from "@babel/runtime/helpers/extends";
import React, { memo, useMemo } from 'react';
import classNames from 'classnames/bind';
import { CellImage, CellLeftSide, CellRightSide } from "./components";
import { withCellClickingWrapper } from "./hocs/withCellClickingWrapper";
import style from "./styles.pcss";
var cn = classNames.bind(style);
export var _Cell = /*#__PURE__*/memo(function (_ref) {
  var leftTitle = _ref.leftTitle,
    leftSubtitle = _ref.leftSubtitle,
    rightTitle = _ref.rightTitle,
    rightSubtitle = _ref.rightSubtitle,
    isReverse = _ref.isReverse,
    extraIcon = _ref.extraIcon,
    actionIcon = _ref.actionIcon,
    linkConfig = _ref.linkConfig,
    buttonConfig = _ref.buttonConfig,
    _ref$testName = _ref.testName,
    testName = _ref$testName === void 0 ? 'Cell' : _ref$testName,
    logo = _ref.logo,
    accessibilityConfig = _ref.accessibilityConfig,
    disabled = _ref.disabled,
    isRightSubtitleCrossedOut = _ref.isRightSubtitleCrossedOut,
    leftSubtitleColor = _ref.leftSubtitleColor,
    readOnly = _ref.readOnly,
    isWithDivider = _ref.isWithDivider,
    className = _ref.className,
    onClick = _ref.onClick;
  var Tag = useMemo(function () {
    if (linkConfig !== null && linkConfig !== void 0 && linkConfig.href) {
      return 'a';
    }
    if (buttonConfig !== null && buttonConfig !== void 0 && buttonConfig.onClick) {
      return 'button';
    }
    return 'div';
  }, [linkConfig, buttonConfig]);
  var targetType = useMemo(function () {
    if (!(linkConfig !== null && linkConfig !== void 0 && linkConfig.target)) return undefined;
    return (linkConfig === null || linkConfig === void 0 ? void 0 : linkConfig.target) || '_blank';
  }, [linkConfig]);
  var isRightSideSeen = useMemo(function () {
    return extraIcon || actionIcon || rightTitle || rightSubtitle;
  }, [actionIcon, extraIcon, rightSubtitle, rightTitle]);
  return /*#__PURE__*/React.createElement(Tag, _extends({
    className: cn('cell-wrap', {
      'cell-wrap--dividered': isWithDivider,
      'cell-wrap--disabled': disabled || readOnly
    }, className)
  }, linkConfig, buttonConfig, accessibilityConfig, {
    "data-component": testName,
    "data-name": "Cell",
    disabled: disabled || readOnly,
    onClick: Tag === 'div' ? undefined : onClick,
    target: targetType,
    type: buttonConfig !== null && buttonConfig !== void 0 && buttonConfig.id ? 'button' : undefined,
    "data-t-id": "src-Cell"
  }), logo && /*#__PURE__*/React.createElement(CellImage, {
    alt: logo.alt,
    custom: logo.custom,
    disabled: disabled,
    icon: logo.icon,
    size: logo.size,
    src: logo.src
  }), /*#__PURE__*/React.createElement("div", {
    className: cn('cell-wrap__content')
  }, (leftTitle || leftSubtitle) && /*#__PURE__*/React.createElement(CellLeftSide, {
    disabled: disabled,
    isFullWidth: !rightTitle && !rightSubtitle && !actionIcon,
    isReverse: isReverse,
    leftSubtitleColor: leftSubtitleColor,
    subtitle: leftSubtitle,
    title: leftTitle
  }), isRightSideSeen && /*#__PURE__*/React.createElement(CellRightSide, {
    actionIcon: actionIcon,
    disabled: disabled,
    extraIcon: extraIcon,
    isCenter: !!leftTitle && !leftSubtitle,
    isReverse: isReverse,
    isRightSubtitleCrossedOut: isRightSubtitleCrossedOut,
    subtitle: rightSubtitle,
    title: rightTitle
  })));
});
_Cell.displayName = _Cell.name;
export var Cell = withCellClickingWrapper(_Cell);